import React, { useState, useEffect } from "react";

function AttributeQuery({ columns = [], values = [], onQueryChange, setShowSelectPopup }) {
  const operatorOptions = [
    "Equal to",
    "Not equal to",
    "Greater than",
    "Greater than equal to",
    "Less than",
    "Less than equal to",
    "is null",
    "is not null",
  ];
  const clauseOptions = ["AND", "OR"];

  // Convert values array into a format where each column has an array of values
  // const columnValues = columns.reduce((acc, col) => {
  //   acc[col] = values.map((row) => (row[col] !== null ? row[col] : "null"));
  //   return acc;
  // }, {});

  const columnValues = columns.reduce((acc, col) => {
    acc[col] = Array.from(new Set(values.map((row) => (row[col] !== null ? row[col] : "null"))));
    return acc;
  }, {});

  const [clauses, setClauses] = useState([{ column: "", operator: "", value: "", clause: "" }]);
  const [query, setQuery] = useState("");

  const addClause = () => {
    setClauses([...clauses, { column: "", operator: "", value: "", clause: "" }]);
  };

  const removeClause = (index) => {
    const updatedClauses = clauses.filter((_, i) => i !== index);
    setClauses(updatedClauses);
  };

  const handleChange = (index, field, value) => {
    const updatedClauses = [...clauses];
    updatedClauses[index][field] = value;
    setClauses(updatedClauses);
  };

  const generateQuery = () => {
    let queryStr = "WHERE ";
    clauses.forEach((clause, index) => {
      if (clause.column && clause.operator) {
        queryStr += `${index > 0 ? clause.clause : ""} ${clause.column} ${clause.operator} '${clause.value}' `;
      }
    });

    setQuery(queryStr.trim());
    console.log("Generated Query:", queryStr);

    // Pass the query conditions back to the parent
    const queryConditions = clauses.map((clause) => ({
      column: clause.column,
      operator: clause.operator,
      value: clause.value,
      clause: clause.clause || "AND", 
    }));
    onQueryChange(queryConditions);
    setShowSelectPopup(false)

  };

  return (
    <>
      <div className="p-3" style={{ border: "2px solid #ccc", overflow: "auto", height: "100%" }}>
        {clauses.map((_, index) => (
          <div className="d-flex align-items-center" key={index}>
            {index === 0 ? (
              <span className="m-2 w-50 form-control" style={{fontSize:'15px'}}>WHERE</span>
            ) : (
              <select
                className="m-2 w-50 form-select" style={{fontSize:'15px'}}
                onChange={(e) => handleChange(index, "clause", e.target.value)}
              >
                <option value="">Select Clause</option>
                {clauseOptions.map((clause, i) => (
                  <option key={i} value={clause}>
                    {clause}
                  </option>
                ))}
              </select>
            )}
            <select
              className="m-2 w-50 form-select" style={{fontSize:'15px'}}
              onChange={(e) => handleChange(index, "column", e.target.value)}
            >
              <option value="">Select Column</option>
              {columns.map((col, i) => (
                <option key={i} value={col}>
                  {col}
                </option>
              ))}
            </select>
            <select
              className="m-2 w-50 form-select" style={{fontSize:'15px'}}
              onChange={(e) => handleChange(index, "operator", e.target.value)}
            >
              <option value="">Select Operator</option>
              {operatorOptions.map((op, i) => (
                <option key={i} value={op}>
                  {op}
                </option>
              ))}
            </select>
            <select
              className="m-2 w-50 form-select" style={{fontSize:'15px'}}
              onChange={(e) => handleChange(index, "value", e.target.value)}
            >
              <option value="">Select Value</option>
              {(columnValues[clauses[index].column] || []).map((value, i) => (
                <option key={i} value={value}>
                  {value}
                </option>
              ))}
            </select>
            {index > 0 && (
              <button className="btn btn-danger m-2" onClick={() => removeClause(index)}>
                Clear
              </button>
            )}
          </div>
        ))}

        <button className="select-attribute" onClick={addClause}>
          Add Clause
        </button>
        
        <button className="select-attribute" onClick={generateQuery}>
          Apply
        </button>

      </div>
    </>
  );
}

export default AttributeQuery;
